import React from "react";
import TableSkeleton from "../Loader/TableSkeleton";

const BuyerSalerTable = ({ Header, body, type }) => {
  return (
    <table className="table">
      <thead>
        <tr>{Header && Header.map((res, key) => <th key={key}>{res}</th>)}</tr>
      </thead>
      <tbody>
        {body ? (
          body.map((res, key) => (
            <tr key={key}>
              {type && type == "buyer" ? (
                <td data-title="Buyer address" className="data-highlight" title={res?.buyers_address || ''}>
                  {res.buyers_address ? res.buyers_address.slice(0, 6) + '...' + res.buyers_address.slice(-4) : "N/A"}
                </td>
              ) : (
                <td data-title="Sellers address" className="data-highlight" title={res?.sellers_address || 'N/A'}>
                  {res.sellers_address ? res.sellers_address.slice(0, 6) + '...' + res.sellers_address.slice(-4) : "N/A"}
                </td>
              )}
              <td data-title="Sale in dollars (ETH)">
                {res?.sales_volume || "N/A"}
              </td>

              {type && type == "buyer" ? (
                <td data-title="Purchases">{res?.purchase || "N/A"}</td>
              ) : (
                <td data-title="Sales">{res?.sale || "N/A"}</td>
              )}
            </tr>
          ))
        ) : (
          <TableSkeleton rows={3} colSpan={3} />
        )}
      </tbody>
    </table>
  );
};

export default BuyerSalerTable;